export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("mouse-coords", {
    created(el, binding) {
      const mouseCoordsCallback = binding.value;

      el.addEventListener("mousemove", (e: MouseEvent) => mouseCoordsCallback(e));
      el.addEventListener("dragover", (e: DragEvent) => mouseCoordsCallback(e));
    },
    unmounted(el, binding) {
      const mouseCoordsCallback = binding.value;

      el.removeEventListener("mousemove", (e: MouseEvent) => mouseCoordsCallback(e));
      el.removeEventListener("dragover", (e: DragEvent) => mouseCoordsCallback(e));
    },
  });
});
